import React from 'react';
interface Props {
  fillColor?: string;
}
function AudiologyIcon({ fillColor = '#17385D' }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="17"
      viewBox="0 0 12 17"
      fill="none">
      <g clipPath="url(#clip0_851_3451)">
        <path
          d="M10.5 6.75C10.5 4.26562 8.48438 2.25 6 2.25C3.51562 2.25 1.5 4.26562 1.5 6.75V12.25C1.5 13.9062 2.84375 15.25 4.5 15.25C6.15625 15.25 7.5 13.9062 7.5 12.25C7.5 11.5719 7.84062 10.9188 8.43125 10.5375C9.67812 9.73438 10.5 8.3375 10.5 6.75ZM12 6.75C12 8.86875 10.9031 10.7312 9.24375 11.7969C9.09062 11.8969 9 12.0656 9 12.25C9 14.7344 6.98438 16.75 4.5 16.75C2.01562 16.75 0 14.7344 0 12.25V6.75C0 3.4375 2.6875 0.75 6 0.75C9.3125 0.75 12 3.4375 12 6.75ZM4 6.75V7.38125C4 7.475 4.05312 7.5625 4.1375 7.60625L4.575 7.825C5.14062 8.10938 5.49687 8.6875 5.49687 9.31875C5.49687 9.81563 5.27812 10.2844 4.89687 10.6031L3.72813 11.5781C3.40938 11.8438 2.9375 11.8 2.67188 11.4812C2.40625 11.1625 2.45 10.6906 2.76875 10.425L3.9375 9.45C3.975 9.41875 4 9.36875 4 9.31875C4 9.25313 3.9625 9.19375 3.90625 9.16562L3.46875 8.94687C2.875 8.65 2.5 8.04375 2.5 7.38125V6.75C2.5 4.81563 4.06563 3.25 6 3.25C7.93437 3.25 9.5 4.81563 9.5 6.75V7C9.5 7.41563 9.16562 7.75 8.75 7.75C8.33438 7.75 8 7.41563 8 7V6.75C8 5.64687 7.10313 4.75 6 4.75C4.89687 4.75 4 5.64687 4 6.75Z"
          fill={fillColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_851_3451">
          <rect
            width="12"
            height="16"
            fill="white"
            transform="translate(0 0.75)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default AudiologyIcon;
